import { isTextClamped } from '@Utils/helpers/stringHelpers';
import React, { useRef } from 'react';
import Styles from './ReworkTable.scss';

interface IReworkCommentProps {
    comment: string;
}

export const ReworkComment = (props: IReworkCommentProps) => {
    const ref = useRef<HTMLSpanElement>(null);

    const handleMouseEnter = () => {
        if (ref.current && isTextClamped(ref.current)) {
            ref.current.title = props.comment;
        }
    };

    return (
        <span
            className={Styles.commentTd}
            ref={ref}
            onMouseEnter={handleMouseEnter}
        >
            {props.comment}
        </span>
    );
};
